<template>
  <v-container fluid>
    <page-title icon="fas fa-fw fa-share-alt">
      Shared Links
      <template v-slot:buttons>
        <v-btn :disabled="form.busy || links.length === 0"
               @click.prevent="exportLinks">
          <v-icon left>
            fas fa-fw fa-download
          </v-icon>
          Export CSV
        </v-btn>
      </template>
    </page-title>

    <v-row>
      <v-col cols="12"
             md="3">
        <v-form @submit.prevent="fetchData"
                :disabled="form.busy">
          <v-card>
            <v-card-title>
              <v-icon left>
                fas fa-fw fa-search
              </v-icon>
              Search
            </v-card-title>
            <v-card-text class="pb-0">
              <v-autocomplete v-model="form.presentation_id"
                              label="Presentation"
                              :items="activePresentations"
                              item-text="name"
                              item-value="id"
                              outlined
                              dense
                              clearable>
              </v-autocomplete>

              <v-select v-model="form.presentation_status"
                        label="Presentation status"
                        :items="['Active', 'Inactive', 'Expired']"
                        outlined
                        dense
                        clearable>
              </v-select>

              <template v-if="canTeamUseSpaces">
                <v-autocomplete v-model="form.space_id"
                                label="Space"
                                :items="spaces"
                                item-text="title"
                                item-value="id"
                                outlined
                                dense
                                clearable>
                </v-autocomplete>

                <v-select v-model="form.space_status"
                          label="Space status"
                          :items="['Active', 'Inactive', 'Expired']"
                          outlined
                          dense
                          clearable>
                </v-select>
              </template>

              <v-text-field v-model="form.name"
                            label="Link name"
                            outlined
                            dense>
              </v-text-field>

              <v-text-field v-model="form.alias"
                            label="Link alias"
                            outlined
                            dense>
              </v-text-field>

              <v-select v-model="form.status"
                        label="Link status"
                        :items="['Active', 'Inactive', 'Expired']"
                        outlined
                        dense
                        clearable>
              </v-select>

              <v-select v-model="form.type"
                        label="Link type"
                        :items="types"
                        item-text="name"
                        item-value="id"
                        outlined
                        dense>
              </v-select>

              <v-autocomplete v-model="form.user_id"
                              label="Link owner"
                              :items="users"
                              item-text="name"
                              item-value="id"
                              outlined
                              dense
                              clearable>
              </v-autocomplete>

            </v-card-text>
            <v-card-actions>
              <v-btn type="submit"
                     color="primary"
                     :disabled="form.busy">
                Search
              </v-btn>

              <v-btn outlined
                     @click.prevent="resetFilter"
                     :disabled="form.busy">
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>

      <v-col cols="12"
             md="9">

        <template v-if="links.length > 0 && pagination">
          <v-card class="mb-4"
                  flat
                  tile>
            <v-toolbar color="primary"
                       dark>
              <v-toolbar-title>
                Showing {{ links.length | number }} of {{ pagination.total | number }} matching {{ links.length | pluralize('link', false) }}
              </v-toolbar-title>
            </v-toolbar>
          </v-card>
          <SharedLinkCard v-for="link in links"
                          :key="link.id"
                          :link="link">
          </SharedLinkCard>
        </template>
        <div v-else-if="form.busy === false"
             class="text-center">
          <p>
            No results.
          </p>
          <v-btn color="primary"
                 @click.prevent="resetFilter">
            Reset
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import PageTitle from '../../components/PageTitle.vue';
import {mapGetters} from 'vuex';
import sharedLinkService from '../../../../ml/services/sharedLinkService';
import SharedLinkCard from './components/SharedLinkCard.vue';
import {concat} from 'lodash';

function initForm() {
  return {
    alias: '',
    notification_level: '',
    name: '',
    presentation_id: '',
    presentation_name: '',
    presentation_type: '',
    presentation_status: '', // MLD-7116
    space_name: '', // MLD-5242
    space_status: '', // MLD-7116
    status: 'Active',
    user_id: '',
    type: '',
    page: 1, // MLD-1618
    per_page: 100, // MLD-1618
    order_by: 'id',
    order_dir: 'desc', // MLD-1885
  }
}

export default {
  components: {SharedLinkCard, PageTitle},
  data() {
    return {
      form: new Form(initForm()),
      links: [],
      pagination: null,
      types: concat([{id: '', name: 'Any'}], sharedLinkService.getTypes()),
    }
  },
  computed: {
    ...mapGetters([
      'activePresentations',
      'canTeamUseSpaces',
      'spaces',
      'users',
    ]),
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      sharedLinkService.getSharedLinks(this.form.data())
        .then(data => {
          this.links = data.data;
          this.pagination = data.meta.pagination;
          this.form.finishProcessing();
        })
        .catch(err => {
          this.form.handleErrors(err);
        })
        .finally(() => {
          this.form.busy = false;
        })
    },
    resetFilter() {
      this.form.reset();
      this.fetchData();
    },
    exportLinks() { // MLD-1665
      const form = {};
      sharedLinkService.exportLinks(form);
    },
  }
}
</script>
